import { ToastStateHandler, UserApi } from '../../../api';
import { PerformEvaluationDto } from '../../../commonTypes/user.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpPerformEvaluation = () => {
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('evaluations');

    const exec = (evaluationId: string, body: PerformEvaluationDto): Promise<void> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.performEvaluation({
                params: { evaluationId },
                body,
                onSuccess: () => {
                    toastHandler.push('success', t('submitEvaluationTitle'), t('submitEvaluationSucceded'));
                    resolve();
                },
                onError: error => {
                    toastHandler.push('error', t('submitEvaluationTitle'), t('submitEvaluationFailed'));
                    reject(error);
                },
            });

            exec();
        });
    };

    return { exec };
};

export default useHttpPerformEvaluation;
